import { useMemo } from 'react';

import { NumberPatternType } from '@dreryk/react-common';
import { NumberInput } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import {
   MedicalDeviceOrderFormRegister,
   MedicalDeviceOrderFormWatch,
   MedicalDeviceOrderSupplyMonthsCountFormBeanPart,
} from '../medicalDeviceOrder.types';
import { isMedicalDeviceFieldRequired } from '../medicalDeviceOrder.utils';

type SupplyMonthsCountFieldProps = {
   readonly register: MedicalDeviceOrderFormRegister<MedicalDeviceOrderSupplyMonthsCountFormBeanPart>;
   readonly watch: MedicalDeviceOrderFormWatch;
};

const SUPPLY_MONTHS_STEP = 1;
const SUPPLY_MONTHS_COUNT_MIN = 1;
const SUPPLY_MONTHS_COUNT_MAX = 12;

export const SupplyMonthsCountField = (props: SupplyMonthsCountFieldProps): JSX.Element => {
   const validationRules = useMemo(() => {
      return {
         required: isMedicalDeviceFieldRequired(props.watch, 'supplyMonthsCount'),
      };
   }, [props.watch]);
   return (
      <NumberInput
         testId={'supplyMonthsCount'}
         label={medicalDevicesTranslationKeys.fields.supplyMonthsCount}
         controller={props.register('supplyMonthsCount', validationRules)}
         min={SUPPLY_MONTHS_COUNT_MIN}
         max={SUPPLY_MONTHS_COUNT_MAX}
         defaultValue={SUPPLY_MONTHS_COUNT_MIN}
         stepValue={SUPPLY_MONTHS_STEP}
         pattern={NumberPatternType.POSITIVE_INTEGER}
      />
   );
};
